import { createSlice } from '@reduxjs/toolkit';
import { getSelf, loginUser } from '../actions/auth-actions';

const AUTH_DATA = 'car_conf_auth';
const REMEMBER_ME = 'rememberMe';

const getAuth = () => {
  const auth =
    JSON.parse(localStorage.getItem(AUTH_DATA)) ||
    JSON.parse(sessionStorage.getItem(AUTH_DATA)) ||
    null;

  return {
    token: auth?.token || null,
    _id: auth?._id || null,
  };
};

const isLoggedIn =
  !!localStorage.getItem(AUTH_DATA) || !!sessionStorage.getItem(AUTH_DATA);

const rememberMe = !!localStorage.getItem(REMEMBER_ME) || false;

const initialState = {
  auth: getAuth(),
  isLoggedIn,
  loggedInUser: null,
  rememberMe,
  isLoading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    logoutHandler(state) {
      state.auth = { token: null, _id: null };
      state.isLoggedIn = false;
      state.loggedInUser = null;
      state.rememberMe = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loginUser.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        if (!action.payload) {
          state.isLoading = false;
          return;
        }

        const { data, rememberMe } = action.payload;

        const storage = rememberMe ? localStorage : sessionStorage;

        const auth = {
          token: data.token,
          _id: data.user.id,
        };

        storage.setItem(AUTH_DATA, JSON.stringify(auth));

        if (rememberMe) {
          localStorage.setItem(REMEMBER_ME, rememberMe);
        }

        state.auth = auth;
        state.loggedInUser = data.user;
        state.isLoggedIn = true;
        state.rememberMe = rememberMe;
        state.isLoading = false;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getSelf.fulfilled, (state, action) => {
        const user = action.payload;

        if (user) {
          state.loggedInUser = user;
        }
      })
      .addCase(getSelf.rejected, (state, action) => {});
  },
});

export const selectLoggedInUser = (state) => state.auth.loggedInUser;

export const authActions = authSlice.actions;

export default authSlice;
